import AxiosInstance from "./api";

export const GoodsReceivedNoteService = {
  getPaginate: async (query) => {
    return await AxiosInstance.get("/private/goods-received-note", { params: query });
  },
  getById: async (id) => {
    return await AxiosInstance.get(`/private/goods-received-note/${id}`);
  },
  create: async (payload) => {
    return await AxiosInstance.post("/private/goods-received-note", payload);
  },
  update: async (id, payload) => {
    return await AxiosInstance.patch(`/private/goods-received-note/${id}`, payload);
  },
  delete: async (id) => {
    return await AxiosInstance.delete(`/private/goods-received-note/${id}`);
  },
};
